import { Error } from '@doda/io-react/common';
import styles from './index.module.scss';

export const UpperLimitErrorText = () => {
  return (
    <p className={styles['validation-text']}>
      <Error size="S" />
      設定できる検索条件は60個までです
    </p>
  );
};
